<template>
  <div
  class="relative flex items-center justify-center mx-auto w-full max-w-[500px] overflow-hidden"
>
  <div
    class="flex gap-7 animate-scroll"
  >
    <!-- Duplicate the set for seamless loop -->
    <div
      v-for="n in 20"
      :key="n"
      class="w-48 h-32 bg-untitled-gray-300 bg-opacity-45 border border-untitled-gray-400 animate-pulse rounded-xl flex items-center justify-center text-white text-xl"
    >

    </div>
  </div>
</div>
</template>

<script setup></script>

<style lang="scss" scoped></style>
